import { ERRORS } from '@/shared/config/error.config';
import { ErrorInfo } from '@/shared/interfaces/error-info.interface';
/**
 * function to get errors description for api errors
 * @param {object} errorConfig error configurations for app
 */
export function getErrorMessage(
  errorConfig: any
): (
  status: number,
  errorCode: string,
  container: string,
  serviceName?: string,
  rawError?: any
) => ErrorInfo {
  return (
    status: number,
    errorCode: string,
    container: string,
    serviceName = 'DEFAULT',
    rawError?: any
  ): ErrorInfo => {
    // handle error containers or DEFAULT container
    console.log('status', status);
    console.log('errorCode', errorCode);
    console.log('container', container);
    console.log('serviceName', serviceName);
    let error =
      container &&
      errorConfig[container] &&
      errorConfig[container][serviceName] &&
      errorConfig[container][serviceName][status] &&
      errorConfig[container][serviceName][status][errorCode]
        ? errorConfig[container][serviceName][status][errorCode]
        : null;
    if (error) {
      return {
        ...error,
        code: errorCode,
        status,
        container,
        serviceName,
        rawError
      };
    }

    error = errorConfig.DEFAULT[status]
      ? errorConfig.DEFAULT[status]
      : errorConfig.DEFAULT.DEFAULT;

    const serverMessage =
      typeof rawError?.message === 'string' && rawError.message.trim()
        ? rawError.message.trim()
        : undefined;

    return {
      ...error,
      errorMessage: serverMessage ?? error.errorMessage,
      ...(serverMessage ? { serverMessage } : {}),
      code: errorCode,
      status,
      container,
      serviceName,
      rawError
    };
  };
}

const errorHelper = getErrorMessage(ERRORS);

export default errorHelper;
